import { ActionType } from "@sp-crm/core";
import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { useIsAllowed } from "store/selectors/hooks";
import { ManageUsersEdit } from "./manage-users-edit";
import { ManageUsersList } from "./manage-users-list";

export const ManageUsers: React.FC<unknown> = () => {
    const manageUsersAllowed = useIsAllowed(ActionType.SelfManageModifyUser);
    if (!manageUsersAllowed) {
        return null;
    }
    return (
        <Switch>
            <Route exact path="/settings/users" component={ManageUsersList} />
            <Route path="/settings/users/:userId" component={ManageUsersEdit} />
            <Route
                path="/settings/users"
                render={() => <Redirect to="/settings/users" />}
            />
        </Switch>
    );
};
